import React from 'react';

interface NotificationIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({
  size = 32,
  color = '#000',
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 32 32"
    className={className}
    {...props}
  >
    <path
      fill={color}
      d="M19.96 25.145a4.002 4.002 0 0 1-7.923 0zM15.997 3.43a9.714 9.714 0 0 1 9.71 9.424v.291h.005v4.7l1.616 4.164q.066.17.088.35l.012.18a1.463 1.463 0 0 1-1.314 1.455l-.15.007H6.027a1.463 1.463 0 0 1-1.41-1.851l.047-.142 1.618-4.165v-4.697a9.714 9.714 0 0 1 9.717-9.716"
    />
  </svg>
);

